import React, { useEffect, useState } from "react";
import { Table, Modal, Button, Badge } from "react-bootstrap";
import { MdOutlineSort } from "react-icons/md";
import { FiInfo } from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";

const TabellaRimessiCompleta = () => {
  const [rimessiRaggruppati, setRimessiRaggruppati] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: 'Data Rimesso', direction: 'desc' });
  const [showModal, setShowModal] = useState(false);
  const [selectedRimesso, setSelectedRimesso] = useState(null);

  useEffect(() => {
    fetch("ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const datiRaw = data?.RIMESSI?.flat() || [];
        const raggruppati = datiRaw.reduce((acc, curr) => {
          const numDoc = curr["Num Rimesso"];
          if (!acc[numDoc]) {
            acc[numDoc] = { 
              ...curr, 
              dettaglioArticoli: [curr],
              totQta: parseFloat(curr.Qta || 0),
            };
          } else {
            acc[numDoc].dettaglioArticoli.push(curr);
            acc[numDoc].totQta += parseFloat(curr.Qta || 0);
          }
          return acc;
        }, {});
        setRimessiRaggruppati(Object.values(raggruppati));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore fetch:", err);
        setLoading(false);
      });
  }, []);

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });

    const sortedData = [...rimessiRaggruppati].sort((a, b) => {
      let valA = a[key] || '';
      let valB = b[key] || '';
      if (key === 'Data Rimesso') { valA = new Date(valA); valB = new Date(valB); }
      return direction === 'asc' ? (valA > valB ? 1 : -1) : (valA < valB ? 1 : -1);
    });
    setRimessiRaggruppati(sortedData);
  };

  return (
<div
  className="shadow-sm card border-0"
  style={{
    borderRadius: "16px",
    height: "380px",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    overflow: "hidden"
  }}
>      
      {/* Header statico del Widget */}
      <div className="p-3 border-bottom d-flex justify-content-between align-items-center bg-white" style={{ zIndex: 110 }}>
        <div className="d-flex align-items-center">
          <span style={{ fontWeight: "800", fontSize: "0.75rem", color: "#1a1a1a", letterSpacing: "1px", marginRight: "8px" }}>
            GESTIONE RIMESSI
          </span>
          <FiInfo size={14} color="#adb5bd" />
        </div>
        <small className="text-muted fw-bold">{rimessiRaggruppati.length} DOCUMENTI</small>
      </div>

<style>{`
        .table-custom { margin-bottom: 0; }
        .table-custom thead th { 
            position: sticky; top: 0; z-index: 10; 
            background-color: #f8f9fa !important; color: #495057 !important; 
            font-size: 0.65rem; text-transform: uppercase; padding: 12px 10px;
            border-bottom: 1px solid #dee2e6 !important;
            cursor: pointer; transition: background 0.2s;
        }
        .table-custom thead th:hover { background-color: #e9ecef !important; }
        .table-custom tbody td { 
            font-size: 0.75rem; padding: 12px 10px; 
            vertical-align: middle; border-bottom: 1px solid #f8f9fa;
        }
        .sort-icon { font-size: 0.85rem; color: #ced4da; margin-left: 4px; }
        .row-hover:hover { background-color: #f8f9ff !important; }
}

`}</style>
<div
  className="scroll-area"
  style={{
    overflowY: "auto",
    flexGrow: 1,
  }}
>
  <Table hover className="table-custom border-0">          <thead>
            <tr>
              <th onClick={() => requestSort('Dep')} style={{ width: "70px" }}>Dep</th>
              <th onClick={() => requestSort('Ragione Sociale')}>Fornitore <MdOutlineSort /></th>
              <th onClick={() => requestSort('Data Rimesso')} style={{ width: "110px" }}>Data</th>
              <th onClick={() => requestSort('Num Rimesso')} style={{ width: "130px" }}>Num. Rimesso</th>
              <th className="text-center" style={{ width: "80px" }}>Articoli</th>
            </tr>
          </thead>
          <tbody>
            {!loading && rimessiRaggruppati.map((row, idx) => (
              <tr key={idx} className="row-link" onClick={() => { setSelectedRimesso(row); setShowModal(true); }}>
                <td style={{fontWeight: '700'}}>{row["Dep"]}</td>
                <td style={{fontWeight: '600'}} className="text-dark text-truncate-custom" title={row["Ragione Sociale"]}>
                  {row["Ragione Sociale"]}
                </td>
                <td>{row["Data Rimesso"] ? new Date(row["Data Rimesso"]).toLocaleDateString("it-IT") : "-"}</td>
                <td style={{fontWeight: '700'}} className="text-primary">{row["Num Rimesso"]}</td>
                <td className="text-center">
                   <Badge bg="light" text="dark" className="border-0">{row.dettaglioArticoli.length}</Badge>
                </td>
              </tr>
            ))}
            {!loading && rimessiRaggruppati.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center py-4 text-muted">Nessun rimesso trovato</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* MODALE (Invariata ma con lo stesso stile pulito se serve) */}
            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered scrollable className="p-5">
        <Modal.Header closeButton className="bg-light">
          <Modal.Title className="small fw-bold">DETTAGLIO RIMESSO: {selectedRimesso?.["Num Rimesso"]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="p-3 bg-white border-bottom">
            <div className="row g-3">
              <div className="col-md-6">
                <label className="text-muted small d-block">Ragione Sociale</label>
                <span className="fw-bold text-dark">{selectedRimesso?.["Ragione Sociale"]}</span>
              </div>
              <div className="col-md-3">
                <label className="text-muted small d-block">Totale Pezzi</label>
                <span className="fw-bold">{selectedRimesso?.totQta}</span>
              </div>
              <div className="col-md-3">
                <label className="text-muted small d-block">Stato Chiusura</label>
                <Badge bg={selectedRimesso?.["Rimesso Chiuso"] === "S" ? "success" : "warning"}>
                  {selectedRimesso?.["Rimesso Chiuso"] === "S" ? "CHIUSO" : "IN CORSO"}
                </Badge>
              </div>
            </div>
          </div>

          <Table responsive striped hover className="mb-0 p-5">
            <thead className="table-light" style={{ fontSize: '0.65rem', textTransform: 'uppercase' }}>
              <tr>
                <th className="ps-3">Codice Articolo</th>
                <th>ID BEM</th>
                <th className="text-center">Qta Ord.</th>
                <th className="text-center">Spuntata</th>
                <th className="text-center">Lavorazione</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: '0.65rem' }}>
              {selectedRimesso?.dettaglioArticoli.map((art, i) => (
                <tr key={i}>
                  <td className="ps-3">{art.articolo || "---"}</td>
                  <td className="bem-label">{art["ID BEM"] || "Non assegnato"}</td>
                  <td className="text-center">{Math.round(art.Qta)}</td>
                  <td className="text-center text-success">{Math.round(art["Qta Spuntata"])}</td>
                  <td className="text-center text-muted small">{art["IN Lavorazione"] || "-"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer className="p-2">
          <Button variant="outline-secondary" size="sm" onClick={() => setShowModal(false)}>Chiudi</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TabellaRimessiCompleta;